export const PARAM_MICROSOFT_CLICK_ID = 'microsoftClickId';
